import { render } from "./Summary.vue?vue&type=template&id=2f959ef3&scoped=true"
const script = {}

import "./Summary.vue?vue&type=style&index=0&id=2f959ef3&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f959ef3"]])

export default __exports__